import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useMemo } from 'react';
import OptionsList, { Item as OptionsListItem, IconButton as OptionsIconButton } from '@/components/lists/Options';
import { ButtonV2 as Button } from '@/components/Button';
import { Input } from '@/components/FormElements';
import optionListStyles from '@/components/lists/Options/styles.module.scss';
import longFormCellSelectionUtils from '@/utils/reporting/longFormCellSelection';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7824 14.1068L10.7896 4.10358C10.053 2.62782 7.9472 2.6278 7.21059 4.10357L2.21763 14.1068C1.55392 15.4365 2.52095 17 4.0071 17H13.9929C15.479 17 16.4461 15.4366 15.7824 14.1068ZM12.579 3.21041C11.1059 0.258875 6.89432 0.258861 5.42112 3.21038L0.428157 13.2136C-0.89926 15.8731 1.03478 19 4.0071 19H13.9929C16.9652 19 18.8992 15.8731 17.5719 13.2137L12.579 3.21041Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13Z",
      fill: "#12131A"
    })]
  }));
};

WarningIcon.defaultProps = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

// Create a list of editable selections for
// a single collection of selections
const SelectionsModalSelectionsList = _ref => {
  let {
    selections,
    maxSelections = Infinity,
    invalidSelections = [],
    highlightColor = '',
    highlightColors = [],
    isAdding = false,
    collectionIndex = 0,
    activeSelection = 0,
    sheetNames = [],
    className,
    onChangeAddMode = () => undefined,
    onActivateSelection = () => undefined,
    onRemoveSelection = () => undefined
  } = _ref;
  // Selections contains one or more items
  // selected from a non-first sheet
  const hasMultipleSheetSelections = useMemo(() => selections.some(selection => longFormCellSelectionUtils.getSheetIndexRef(selection) !== '0'), [selections]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OptionsList, {
      className: className,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [selections.map((selection, selectionIndex) => {
          // Replace combined result sheet reference
          // with the combined sheet name for UX
          const userFacingSelection = longFormCellSelectionUtils.toUserFacingSelection(selection, {
            addSheetRef: hasMultipleSheetSelections,
            sheetNames
          });
          return /*#__PURE__*/_jsxs(OptionsListItem, {
            children: [/*#__PURE__*/_jsxs("div", {
              className: optionListStyles.column,
              onClick: () => {
                if (selection) onActivateSelection(selectionIndex);
              },
              children: [/*#__PURE__*/_jsx("style", {
                type: "text/css",
                children: `.selectionOption${collectionIndex}${selectionIndex}, .selectionOption${collectionIndex}${selectionIndex}:hover { color: ${highlightColor || highlightColors[selectionIndex]}; border-color: ${highlightColor || highlightColors[selectionIndex]}; }`
              }), /*#__PURE__*/_jsx(Input, {
                className: clsx(styles.input, styles['input--selectable'], `selectionOption${collectionIndex}${selectionIndex}`, activeSelection === selectionIndex ? styles['input--active'] : ''),
                placeholder: "A1:A2",
                value: userFacingSelection,
                rightIcon: invalidSelections.includes(selection) || selectionIndex > maxSelections - 1 ? /*#__PURE__*/_jsx(WarningIcon, {}) : /*#__PURE__*/_jsx(_Fragment, {}),
                readOnly: true
              })]
            }), selections.length > 1 || collectionIndex !== 0 ? /*#__PURE__*/_jsx(OptionsIconButton, {
              type: "trash",
              onClick: () => onRemoveSelection(selectionIndex)
            }) : /*#__PURE__*/_jsx(_Fragment, {})]
          }, `selection-option-${collectionIndex}-${selectionIndex}`);
        }), isAdding ? /*#__PURE__*/_jsxs(OptionsListItem, {
          children: [/*#__PURE__*/_jsx("div", {
            className: optionListStyles.column,
            children: /*#__PURE__*/_jsx(Input, {
              className: clsx(styles.input, styles['input--active']),
              placeholder: "A1:A2",
              disabled: true
            })
          }), selections.length > 1 ? /*#__PURE__*/_jsx(OptionsIconButton, {
            type: "trash",
            onClick: () => onChangeAddMode(false)
          }) : /*#__PURE__*/_jsx(_Fragment, {})]
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      })
    }), !isAdding && selections.length < maxSelections && /*#__PURE__*/_jsx(Button, {
      variant: "tertiary",
      size: "large",
      className: "-l-fullWidth",
      onClick: () => onChangeAddMode(true),
      children: "Add Selection"
    })]
  });
};

export default SelectionsModalSelectionsList;